(() => {
  var __defProp = Object.defineProperty;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __publicField = (obj, key, value) => {
    __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
  };

  // node_modules/loadx/dist/loadx.module.js
  var n = function() {
    var n2 = {};
    function r(r2, t, e) {
      return new Promise(function(o, u) {
        if (t === null || !(t instanceof HTMLElement))
          return u(new Error("Parent not found."));
        var c = function(r3) {
          var t2 = JSON.stringify(r3), e2 = n2[t2];
          return e2 !== void 0 ? e2 : null;
        }(e);
        if (c !== null)
          return o(c);
        var i = document.createElement(r2);
        i.onload = function() {
          o(i), function(r3, t2) {
            var e2 = JSON.stringify(r3);
            n2[e2] = t2;
          }(e, i);
        }, i.onerror = function(n3) {
          u(new URIError("The asset " + n3.target.src + " didn't load correctly."));
        }, Object.keys(e).forEach(function(n3) {
          i[n3] = e[n3];
        }), t.appendChild(i);
      });
    }
    return r.js = function(n3) {
      return r("script", document.body, { src: n3 });
    }, r.css = function(n3) {
      return r("link", document.head, { type: "text/css", rel: "stylesheet", href: n3 });
    }, r.img = function(n3, t) {
      return r("img", function(n4) {
        return n4 === void 0 ? document.body : n4;
      }(t), { src: n3 });
    }, r;
  }();

  // src/js/components/video.js
  var _Video = class {
    static async init() {
      if (!window.Store.app.theContainer.querySelectorAll(_Video.param.selector).length) {
        return false;
      }
      if (!window.Store.components.video.lib_loaded) {
        let script = document.createElement("script");
        new Promise((resolve, reject) => {
          window.Store.app.theBody.appendChild(script);
          script.onload = resolve;
          script.onerror = reject;
          script.async = true;
          script.src = "https://www.youtube.com/iframe_api";
          script.id = "youtube_api";
        }).then(() => {
          const youtubeReady = function() {
            window.removeEventListener("youtube_ready", youtubeReady);
            window.Store.components.video.lib_loaded = true;
            window.Store.components.video.obj = _Video.create();
          };
          window.addEventListener("youtube_ready", youtubeReady);
        });
      } else {
        window.Store.components.video.obj = _Video.create();
      }
    }
    static create() {
      const videos = window.Store.app.theContainer.querySelectorAll(_Video.param.selector);
      let objects = [];
      if (!videos.length) {
        return null;
      }
      videos.forEach((video) => {
        const id = video.dataset.video;
        const isLazyload = video.dataset.videoLazyload == "true" ? true : false;
        const isBackground = video.dataset.videoBackground == "true" ? true : false;
        const autoplay = video.dataset.autoplay == "true" ? true : false;
        const mute = video.dataset.mute == "true" ? true : false;
        const obj = new _Video(video, id, isLazyload, isBackground, autoplay, mute);
        obj.init();
        objects.push(obj);
      });
      return objects;
    }
    static stopAllVideos(exceptionPlayer = null) {
      window.Store.components.video.obj.forEach((videoInstance) => {
        if (videoInstance.player && typeof videoInstance.player.getPlayerState === "function" && videoInstance.player.getPlayerState() === 1) {
          if (!exceptionPlayer || exceptionPlayer && videoInstance.player !== exceptionPlayer) {
            videoInstance.videoStop();
          }
        }
      });
    }
    constructor(element, videoId, isLazyload, isBackground, autoplay, mute) {
      this.element = element;
      this.videoId = videoId;
      this.isLazyload = isLazyload ?? false;
      this.isBackground = isBackground ?? false;
      this.autoplay = autoplay;
      this.mute = mute;
      this.player = null;
    }
    init() {
      if (this.isLazyload) {
        const callback = (e) => {
          e.preventDefault();
          this.initPlayer(this.element.querySelector("a"));
          this.element.removeEventListener("click", callback);
        };
        this.element.addEventListener("click", callback);
        return false;
      }
      return this.initPlayer();
    }
    initPlayer(container) {
      this.handleAttributes();
      const player = new YT.Player(container ?? this.element, {
        videoId: this.videoId,
        playerVars: {
          "controls": 0,
          "showinfo": 0,
          "rel": 0,
          "loop": this.autoplay ?? 0,
          "autoplay": this.autoplay ?? 0,
          "playlist": this.videoId,
          "mute": this.mute,
          "modestbranding": 1,
          "origin": window.location.origin
        },
        events: {
          "onReady": this.onPlayerReady,
          "onStateChange": this.onStateChange
        }
      });
      if (window.Store.components.video.obj) {
        window.Store.components.video.obj.forEach((videoInstance, index) => {
          if (videoInstance === this) {
            window.Store.components.video.obj[index].player = player;
          }
        });
      }
      return player;
    }
    handleAttributes() {
      if (this.isBackground) {
        this.videoRescale();
      }
    }
    onPlayerReady(event) {
      event.target.getIframe().classList.add(_Video.param.modifiers.ready);
      event.target.playVideo();
    }
    onStateChange(event) {
      if (event.data === 1) {
        _Video.stopAllVideos(event.target);
      }
    }
    videoRescale() {
      const w = window.Store.scrollbar.world.w + 200;
      const h = window.Store.scrollbar.world.h + 200;
    }
    videoStop() {
      this.player.getIframe().classList.remove(_Video.param.modifiers.playing);
      this.player.stopVideo();
    }
  };
  var Video = _Video;
  __publicField(Video, "param", {
    selector: "[data-video]",
    modifiers: {
      ready: "is-ready",
      playing: "is-playing"
    }
  });
  function render() {
    Video.init();
  }
  window.Store.components.video.render = render;
})();
